'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetCompetitionsRow } from '@morfi/backend-sdk-v2/client';
import { useGetCompetitions } from '@morfi/backend-sdk-v2/client';
import type { ReactNode } from 'react';
import { CompetitionBanner } from '@/components/social/competition/competition-banner';
import { useClientNowMs } from '@/components/social/competition/use-client-now';
import { useLiveListData } from '@/hooks/sdk/use-live-list-data';
import { toCompetitionSummaries } from '@/lib/competitions/from-sdk';

/**
 * Social-page banner owner: published competitions, including concluded ones.
 * Shares the archive read so the last competition remains discoverable after
 * it ends. Pinned competitions retain priority within the returned page.
 *
 * The banner is omitted entirely when nothing is scheduled — including while
 * the first read is in flight, so the Social page never reserves space for a
 * carousel that may not exist.
 */
export function CompetitionBannerData(t0) {
  const $ = _c(7);
  const {
    timeZone
  } = t0;
  const initialNowMs = useClientNowMs();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const query = useGetCompetitions(t1);
  const rows = useLiveListData(query.queryKey);
  let t2;
  if ($[1] !== rows) {
    t2 = toCompetitionSummaries(rows.toSorted(_temp));
    $[1] = rows;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const slides = t2;
  if (slides.length === 0) {
    return null;
  }
  let t3;
  if ($[3] !== initialNowMs || $[4] !== slides || $[5] !== timeZone) {
    t3 = <CompetitionBanner slides={slides} initialNowMs={initialNowMs} timeZone={timeZone} />;
    $[3] = initialNowMs;
    $[4] = slides;
    $[5] = timeZone;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(a, b) {
  return Number(b.pinned) - Number(a.pinned);
}